module.exports = __webpack_public_path__ + "static/media/stofferingen-21.2d5c19f1.jpg";